import type { TFunction } from 'i18next'

export const createFormatters = (t: TFunction) => ({
  formatArea: (area?: number) =>
    area ? `${Math.round(area).toLocaleString()} m²` : t('common.na'),

  formatHeight: (h?: number) => (h ? `${h.toFixed(1)} m` : t('common.na')),

  formatNumber: (num?: number) => (num ? num.toLocaleString() : t('common.na')),
})
